export default __webpack_public_path__ + "static/media/logo138x75white.ca1bb183.png";